import hasuraDataProvider from './ra-data-hasura';
import { HASURA_SERVER, ANONYMOUS_JSON_WEB_TOKEN } from '../constants';
import { fetchUnusedTourGroupIds } from '../api';

const headers = () => {
  const jsonWebToken = window.localStorage.getItem('jsonWebToken') || ANONYMOUS_JSON_WEB_TOKEN;
  const headers = {
    'content-type': 'application/json',
    Authorization: 'Bearer ' + jsonWebToken,
  };
  return headers;
};

const hasuraDataProviderWithSetup = hasuraDataProvider(HASURA_SERVER, headers);

// TOTP columns are managed exclusively by apollo-server resolvers. They must
// never appear in $set payloads from the backoffice — totpBackupCodes is a
// text[] which Hasura rejects when sent as a JSON array.
const USER_MANAGED_FIELDS = ['totpSecret', 'totpEnabled', 'totpBackupCodes'];

function stripManagedFields(data) {
  if (!data) return data;
  const clean = { ...data };
  USER_MANAGED_FIELDS.forEach(f => delete clean[f]);
  return clean;
}

export default async (type, resource, params, options) => {
  if (type === 'CUSTOM') {
    if (resource === 'fetchUnusedTourGroupIds') {
      return fetchUnusedTourGroupIds();
    }
    throw new Error(`Unknow resource "${ resource }" for type CUSTOM`);
  }
  if (resource === 'user' && (type === 'UPDATE' || type === 'UPDATE_MANY' || type === 'CREATE')) {
    params = { ...params, data: stripManagedFields(params.data) };
  }
  return hasuraDataProviderWithSetup(type, resource, params, options);
};
